<script setup lang="ts">
import type { AccordionData } from '~/utils/crystallize/pieces'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  item: NonNullable<AccordionData['items']>[number]
}>()
</script>

<template>
  <details class="group">
    <summary class="py-s px-l flex justify-between items-center">
      <h3 class="title-s" v-text="item.summary" />

      <Icon
        :icon="faChevronDown"
        class="transition-transform group-open:rotate-180"
      />
    </summary>

    <div class="px-l pb-l flex flex-col gap-m">
      <CrystallizeRichText v-for="(block, i) in item.content" :key="i" :block="block" />
    </div>
  </details>
</template>
